/* eslint-disable */
import Vue from 'vue'

import { registerPlugins } from './plugins'
import { createVuetify } from './_vuetify'
import { createStore } from './_store'
import { createRouter } from './_router'

import App from './App.vue'

import VueAppInsights from 'vue-application-insights'

registerPlugins(Vue);

Vue.config.productionTip = false;

const vuetify = createVuetify();
const store = createStore();
const router = createRouter();

Vue.use(VueAppInsights, {
    baseName: 'ScheduleOnline-Vue', // prefix to track route changes as page views with AppInsights
    id: Vue.appConfig.appInsightsKey,
    appInsightsConfig: { autoTrackPageVisitTime: true },
    router
})

new Vue({
    store,
    router,
    vuetify,
    render: h => h(App),
}).$mount("#app")
